<section class="gradient-section-theme-color1">
  <div class="container">
    <h1>
      Calorie Calculator
    </h1>
  </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a></li>
      <li class="breadcrumb-item"><a href="/tools">Tools</a></li>
      <li class="breadcrumb-item active" aria-current="page">Calorie Calculator</li>
    </ol>
  </nav>

  <div class="mt-5">
    <div class="calorie-calculator">
      <p>Use this tool to calculate your daily calorie needs. Enter your age, gender, height in centimeters,
        weight in kilograms, and activity level, then click the "Calculate Calories" button to see your result.
      </p>

      <form [formGroup]="calorieForm" (ngSubmit)="calculateCalories()" class="calorie-form">
        <div class="form-group">
          <label for="age">Age:</label>
          <input type="number" id="age" formControlName="age" class="form-control" required>
        </div>

        <div class="form-group">
          <label>Gender:</label>
          <div class="form-check">
            <input type="radio" id="male" formControlName="gender" value="male" class="form-check-input" required>
            <label for="male" class="form-check-label">Male</label>
          </div>
          <div class="form-check">
            <input type="radio" id="female" formControlName="gender" value="female" class="form-check-input" required>
            <label for="female" class="form-check-label">Female</label>
          </div>
        </div>

        <div class="form-group">
          <label for="height">Height (cm):</label>
          <input type="number" id="height" formControlName="height" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="weight">Weight (kg):</label>
          <input type="number" id="weight" formControlName="weight" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="activity">Activity Level:</label>
          <select id="activity" formControlName="activityLevel" class="form-control" required>
            <option value="sedentary">Sedentary (little or no exercise)</option>
            <option value="light">Lightly active (light exercise/sports 1-3 days/week)</option>
            <option value="moderate">Moderately active (moderate exercise/sports 3-5 days/week)</option>
            <option value="active">Active (hard exercise/sports 6-7 days a week)</option>
            <option value="very-active">Very active (very hard exercise/sports & physical job)</option>
          </select>
        </div>
        <div class="form-group mt-3">
          <button type="submit" class="btn btn-primary">Calculate Calories</button>
        </div>
      </form>
      <div class="col-xs-12" style="height:50px;"></div>

      @if (calorieResult !== null) {
        <div>
          <div>Your daily calorie needs are: <strong>{{ calorieResultStr }}</strong> calories</div>
        </div>
      }
    </div>
  </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>
